import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';

import {CONFIG} from 'src/global-config';

import {LoadingScreen} from 'src/components/loading-screen';

import {AuthGuard} from 'src/auth/guard';

import {AppsLayout} from "../../layouts/etikettenentfernung";

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/apps/etikettenentfernung/events-live'));


const EtikettenentfernungEventsListPage = lazy(() => import('src/pages/apps/etikettenentfernung/events-list'));
const EtikettenentfernungEventsLiveViewPage = lazy(() => import('src/pages/apps/etikettenentfernung/events-live'));
const EtikettenentfernungCleaningImagesListPage = lazy(
  () => import('src/pages/apps/etikettenentfernung/cleaning-images-list'),
);
const EtikettenentfernungCleaningImageViewPage = lazy(
  () => import('src/pages/apps/etikettenentfernung/cleaning-image-view'),
);
const EtikettenentfernungViewPage = lazy(() => import('src/pages/apps/etikettenentfernung/event-view'));
const ReboPipelineEventsListPage = lazy(() => import('src/pages/apps/rebo-pipeline/events-list'));
const ReboPipelineEventsLiveViewPage = lazy(() => import('src/pages/apps/rebo-pipeline/events-live'));
const ReboPipelineViewPage = lazy(() => import('src/pages/apps/rebo-pipeline/event-view'));
const WebUploadsPage = lazy(() => import('src/pages/apps/web-uploads'));
const WebUploadViewPage = lazy(() => import('src/pages/apps/web-uploads/event-view'));

// ----------------------------------------------------------------------

const layoutContent = (
  <AppsLayout>
    <Suspense fallback={<LoadingScreen/>}>
      <Outlet/>
    </Suspense>
  </AppsLayout>
);

export const appsRoutes = [
  {
    path: 'apps',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      {element: <IndexPage/>, index: true},
      {
        path: 'etikettenentfernung',
        children: [
          {element: <EtikettenentfernungEventsLiveViewPage/>, index: true},
          {path: 'live', element: <EtikettenentfernungEventsLiveViewPage />},
          {path: 'list', element: <EtikettenentfernungEventsListPage />},
          {path: 'cleaning-images', element: <EtikettenentfernungCleaningImagesListPage />},
          {path: 'cleaning-images/:id/view', element: <EtikettenentfernungCleaningImageViewPage />},
          {path: ':id/view', element: <EtikettenentfernungViewPage/>}
        ]
      },
      {
        path: 'web-uploads',
        children: [
          { element: <WebUploadsPage />, index: true },
          { path: ':id/view', element: <WebUploadViewPage /> },
        ],
      },
      {
        path: 'rebo-pipeline',
        children: [
          { element: <ReboPipelineEventsLiveViewPage />, index: true },
          { path: 'live', element: <ReboPipelineEventsLiveViewPage /> },
          { path: 'list', element: <ReboPipelineEventsListPage /> },
          { path: ':id/view', element: <ReboPipelineViewPage /> },
        ],
      },

    ],
  },
];
